import { render, staticRenderFns } from "./ReportesIVA.vue?vue&type=template&id=66ffbcda"
import script from "./ReportesIVA.vue?vue&type=script&lang=js"
export * from "./ReportesIVA.vue?vue&type=script&lang=js"
import style0 from "./ReportesIVA.vue?vue&type=style&index=0&id=66ffbcda&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports